import { createVanIconComponent } from "./van"

const FontOutlined = createVanIconComponent("font-o")
export default FontOutlined
